import styled from "styled-components";

const StatusContainer = styled.div`
    display: flex;
    width: 100px;
    height: 32px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;

    ${(props) => props.theme.fonts.variant.bold()}
    font-size: 10px;
    font-style: normal;
    line-height: normal;
`;

export const CancelledStatus = styled(StatusContainer)`
    background: #FCDFDE;
    color: #B13832;
    border: 1px solid #B13832;
`;

export const DraftStatus = styled(StatusContainer)`
    background: #F1F2F4;
    color: #434B57;
    border: 1px solid #434B57;
`;

export const ScheduledStatus = styled(StatusContainer)`
    background: #D8E6FC;
    color: #2842CC;
    border: 1px solid #2842CC;
`;

export const RunningStatus = styled(StatusContainer)`
    background: #DDE3FD;
    color: #3E30BD;
    border: 1px solid #3E30BD;
`;

export const FinishedStatus = styled(StatusContainer)`
    background: #D9FBE5;
    color: #438B58;
    border: 1px solid #438B58;
`;

export const ArchivedStatus = styled(StatusContainer)`
    background: #F1F2F4;
    color: #313946;
    border: 1px solid #313946;
`;

export const ManualStatus = styled(StatusContainer)`
    background: #ECFEFF;
    color: #0E7490;
    border: 1px solid #0E7490;
`;
